import { EMPTY_PLACEHOLDER } from 'cpool-constants';
import type { SchemaEuropaceProcessEvent, SchemaEuropaceProcessOfferEvent } from 'cpool-schemas';

import { Document } from './Document';
import { Link } from './Link';

type Props = {
    documents: SchemaEuropaceProcessOfferEvent['documents'] | SchemaEuropaceProcessEvent['documents'];
    links: SchemaEuropaceProcessOfferEvent['links'];
    europaceOfferId?: SchemaEuropaceProcessOfferEvent['europaceOfferId'];
};

export const DocumentList: React.FC<Props> = ({ documents, europaceOfferId, links }) => {
    if ((!links && !documents) || (links && links.length === 0 && documents && documents.length === 0))
        return <div className="text-center justify-center">{EMPTY_PLACEHOLDER}</div>;

    // NOTE: Check is needed so that we can display the placeholder (EMPTY_PLACEHOLDER) if only empty fields exist
    const linkList = links
        ? links.map((link, index) =>
              !link.title && !link.url ? null : (
                  <Link key={`link-${index}`} link={link} europaceOfferId={europaceOfferId} />
              ),
          )
        : [];
    const documentList = documents
        ? documents.map((doc, index) =>
              !doc.displayName && !doc.uri ? null : <Document key={`document-${index}`} document={doc} />,
          )
        : [];

    const documentsList = [...linkList, ...documentList];

    if (documentsList.length === 0 || documentsList.every((doc) => doc === null))
        return <div className="text-center justify-center">{EMPTY_PLACEHOLDER}</div>;

    return <ul className="space-y-1.5">{documentsList}</ul>;
};
